module.exports = __webpack_public_path__ + "img/7_62.916f2324.png";